module.exports = __webpack_public_path__ + "static/img/nav_bg.87949784.png";